import axios from 'axios';
import jwtDecode from 'jsonwebtoken';
import {Notification} from 'element-ui';

if (process.env.NODE_ENV !== 'production' || !window['renewal-form']) {
  window['renewal-form'] = {
      title: 'test config',
      configurationSet:'renewal-member'
  }
}

const getProductInfo = (offerProduct, code) => {
  const prod = offerProduct.find((op) => op.product_code === code);
  if (prod) {
    const gstProd = offerProduct.find((op) => op.product_code === `${code}GST`);
    const selected = { 'product-code': prod.product_code, 'product-description': prod.product_description, price: prod.price };

    if (gstProd) {
      selected['total-price'] = prod.price + gstProd.price;
      selected['gst'] = gstProd;
    } else {
      selected['total-price'] = prod.price;
    }

    return selected;
  }

  return null;
}

export default {
  namespaced: true,
  state: () => ({
    status: 'loading', // loading, success, error, pending-payment
    configurationSet: window['renewal-form']['configurationSet'],
    configSettings: {},
    offerSettings: {},
    donationSettings: {},
    oneClick: {},
    jwt: null,
    step: 1,
    payload: {
      membershipForm: {
        members: [],
        previousProducts: null,
        standardProducts: null,
        secondaryProducts: null
      },
      donation: {
        monthly: false,
        amount: 0,
        custom: false,
      },
      donorInfo: {
        address: {},
        email: null,
        mobile: null,
      },
      jnrProduct: false,
    },
    receipt: null,
    donorRole: [],
    accessToken: null
  }),
  mutations: {
    setStatus(state, payload) {
      state.status = payload;
    },
    setConfigSettings(state, payload) {
      state.configSettings = payload;
    },
    setOfferSettings(state, payload) {
      state.offerSettings = payload;
    },
    setDonationSettings(state, payload) {
      state.donationSettings = payload;
    },
    setPayload(state, payload) {
      state.payload = { ...state.payload, ...payload };
    },
    setOneClick(state, payload) {
      state.oneClick = payload;
    },
    setJWT(state, payload) {
      state.jwt = payload;
    },
    setStep(state, payload) {
      state.step = payload;
    },
    setReceipt(state, payload) {
      state.receipt = payload;
    },
    setDonorRole(state, payload) {
      state.donorRole = [...payload];
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
    }
  },
  actions: {
    async getConfigurationSet({ state, dispatch, commit, rootState }, payload) {
      commit('setStatus', 'loading');
      axios.defaults.baseURL = rootState.baseURL;

      try {
        let configStatus = 'success';
        // get token
        if (payload.token !== '') {
          const decoded = jwtDecode.decode(payload.token, { complete: true });
          commit('setAccessToken', payload.token);
          commit('setDonorRole', decoded.payload.Role);
        }

        // get config
        const resConfig = await axios({ method: 'get', url: `config/${state.configurationSet}` });
        commit('setConfigSettings', resConfig.data[state.configurationSet]);

        // get jwt / contact info (already set in state on mount of parent component)
        const eventUser = rootState.auth.eventUser

        // const eventUser = await dispatch('auth/getContactDetail', null, {root:true})
        /*
        const oneClickData = { 'one_click_token': payload.ck, 'one_click_module': 'CONTACT-UPDATE' };
        const resOneClick = await axios({
          method: 'post',
          url: `registration/${payload.id}/oneclick`,
          data: oneClickData
        });
        const eventUser = resOneClick.data;
*/


        commit('setOneClick', eventUser);
        commit('setPayload', { donorInfo: { address: eventUser.address, email: eventUser.email, mobile: eventUser.mobile }});
        // const jwt = resOneClick.data?.jwt;
        const jwt = eventUser?.jwt;
        commit('setJWT', jwt);

        if (jwt) {

          // get
          const id = eventUser.id

          const offerData = { jwt }
          const resOffer = await axios({ method: 'post', url: `renewal/offer/${id}`, data: offerData});
          commit('setOfferSettings', resOffer.data);

          const { options, products } = resOffer.data;
          if (!products || products.length === 0 || (products.length === 1 && products[0].product_code.toLowerCase() === 'vol')) {
            configStatus = 'renewed-already';
          } else if (options['pending-payments-exist']) {
            configStatus = 'pending-payment';
          } else {
            await dispatch('getDonationConfigurationSet');
          }
        } else {
          configStatus = 'error';
        }

        commit('setStatus', configStatus);
        if (configStatus === 'error') {
          Notification.error({ message: "An error has occurred and we're unable to process your renewal" });
        }
      } catch (error) {
        commit('setStatus', 'error');
        console.log(error)
        Notification.error({ message: "An error has occurred and we're unable to process your renewal" });
      }
    },
    async sendConcession({ state, rootState }, payload) {
      axios.defaults.baseURL = rootState.baseURL;

      try {
        const file = payload.map((blob) => ({ type: 'Image', blob }));
        const concessionData = { jwt: state.jwt, file };
        await axios({ method: 'post', url: `renewal/concession/${state.oneClick.id}`, data: concessionData });
        return true;
      } catch (error) {
        console.log(error)
        Notification.error({ message: "An error has occurred and we're unable to process the proof of concession" });
        return false;
      }
    },
    async getDonationConfigurationSet({ state, commit, rootState }) {
      commit('setStatus', 'loading');
      axios.defaults.baseURL = rootState.baseURL;

      try {
        const configName = state.configSettings['renewal-donation-config-set'];
        const resConfig = await axios({ method: 'get', url: `config/${configName}` });
        commit('setDonationSettings', resConfig.data[configName]);

        commit('setStatus', 'success');
      } catch (error) {
        commit('setStatus', 'error');
        console.log(error)
        Notification.error({ message: "An error has occurred and we're unable to process your renewal" });
      }
    },
    async sendElectoralAddress({ getters, rootState }) {
      axios.defaults.baseURL = rootState.baseURL;

      try {
        const donorInformation = getters.donorInformation;
        const userInfo = getters.userInfo;
        const electoralData = {
          prefix: donorInformation.prefix,
          first_name: donorInformation.first_name,
          last_name: donorInformation.last_name,
          dob: donorInformation.dob,
          mobile: userInfo.mobile,
          address: {
            address_1: userInfo.address.address_1,
            suburb: userInfo.address.suburb,
            state: userInfo.address.state,
            post_code: userInfo.address.post_code
          }
        }

        const validationResult = await axios({ method: 'post', url: 'donation-management/validate-electoral-roll', data: electoralData });
        return validationResult.data.validation_result;
      } catch (error) {
        console.log(error)
        Notification.error({ message: "An error has occurred when verify your address." });
        return 'invalid';
      }
    },
    async updateContactElectoral({ state, getters, rootState }) {
      axios.defaults.baseURL = rootState.baseURL;

      try {
        const donorInformation = getters.donorInformation;
        const userInfo = getters.userInfo;
        const electoralData = {
          jwt: state.jwt,
          prefix: donorInformation.prefix,
          first_name: donorInformation.first_name,
          last_name: donorInformation.last_name,
          dob: donorInformation.dob,
          mobile: userInfo.mobile,
          email: userInfo.email !== '' ? userInfo.email : null,
          address: {
            ...userInfo.address,
            address_1: userInfo.address.address_1,
            suburb: userInfo.address.suburb,
            state: userInfo.address.state,
            post_code: userInfo.address.post_code
          }
        }

        await axios({ method: 'post', url: `contact/electoral/${state.oneClick.id}`, data: electoralData });
        return 'valid';
      } catch (error) {
        console.log(error)
        Notification.error({ message: "An error has occurred when updating your profile." });
        return 'invalid';
      }
    },
    async renewalPayment({ state, getters, commit, rootState }, payload) {
      axios.defaults.baseURL = rootState.baseURL;

      try {
        const membershipForm = getters.membershipForm;
        const donation = getters.donation;
        const isStaffUser = getters.isStaffUser;
        const errorMsg = getters.donationValidationMsg;
        const products = [];
        let amount = 0;

        if (membershipForm.previousProducts) {
          products.push({
            product_code: membershipForm.previousProducts['product-code'],
            product_description: membershipForm.previousProducts['product-description'],
            price: membershipForm.previousProducts.price
          });
          products.push({ ...membershipForm.previousProducts.gst });
          amount += membershipForm.previousProducts['total-price'];
        }

        if (membershipForm.standardProducts) {
          products.push({
            product_code: membershipForm.standardProducts['product-code'],
            product_description: membershipForm.standardProducts['product-description'],
            price: membershipForm.standardProducts.price
          });
          products.push({ ...membershipForm.standardProducts.gst });
          amount += membershipForm.standardProducts['total-price'];
        }

        if (membershipForm.secondaryProducts) {
          products.push({
            product_code: membershipForm.secondaryProducts['product-code'],
            product_description: membershipForm.secondaryProducts['product-description'],
            price: membershipForm.secondaryProducts.price
          });
          products.push({ ...membershipForm.secondaryProducts.gst });
          amount += membershipForm.secondaryProducts['total-price'];
        }

        if (donation.amount > 0) {
          amount += donation.amount;
        }

        const paymentData = {
          jwt: state.jwt,
          products,
          payment: {
            donation: { monthly: donation.monthly, donation_amount: donation.amount },
            membership: {
              ...payload,
              amount,
              staff_user_in_role: isStaffUser
            }
          }
        }

        const paymentEndpoint = `renewal/${isStaffUser ? 'staff' : ''}payment/${state.oneClick.id}`;
        let requestConfig = { method: 'post', url: paymentEndpoint, data: paymentData };

        if (isStaffUser) {
          requestConfig = {
            ...requestConfig,
            headers: { 'Authorization': `bearer ${state.accessToken}` },
          };
        }

        const paymentResult = await axios(requestConfig);

        // assign result
        const result = {
          ...paymentResult.data
        }

        // add last 4 card number if card in payload
        // note: only checking errors if credit card payment due to issues with non-cc payments
        // todo: fix all of this!
        if (payload.card_number) {
          result.last_4_card = payload.card_number.substring(payload.card_number.length - 4)

          switch (paymentResult.data.response_status) {
            case 'failed_cc':
              Notification.error({ message: errorMsg["invalid-credit-card-violation"] });
              break;

            case 'failed_businessrules':
              Notification.error({ message: errorMsg["invalid-business-rule-violation"] });
              break;

            case 'failed_error':
              Notification.error({ message: errorMsg["technical-issue-credit-card-payment"] });
              break;

            default:
              break;
          }

        }

        commit('setReceipt', result);

        return result;

      } catch (error) {
        console.log(error)
        Notification.error({ message: "An error has occurred when doing payment." });
        return null;
      }
    },
  },
  getters: {
    members(state) {
      return state.offerSettings.members.map((m) => ({ id: m.id, fullName: m["full-name"], initial: m.initials, otherDetails: m.id, color: "#0F589E" }))
    },
    offerProducts(state) {
      return state.offerSettings.products;
    },
    configOptions(state) {
      return state.configSettings;
    },
    offerOptions(state) {
      return state.offerSettings.options;
    },
    donationOptions(state) {
      return state.donationSettings;
    },
    donorInformation(state) {
      return state.oneClick;
    },
    membershipForm(state) {
      return state.payload.membershipForm;
    },
    donation(state) {
      return state.payload.donation;
    },
    userInfo(state) {
      return state.payload.donorInfo;
    },
    jnrProduct(state) {
      return state.payload.jnrProduct;
    },
    paymentValidationMsg(state, getters) {
      return getters.donationOptions['validation-payment-form'];
    },
    donationValidationMsg(state, getters) {
      return getters.donationOptions['validation-donation-form'];
    },
    previousProducts(state, getters) {
      const prevProduct = state.configSettings['previous-year']?.products;
      const offerProduct = getters.offerProducts;

      if (prevProduct && offerProduct) {
        return prevProduct.map((p) => getProductInfo(offerProduct, p['product-code'])).filter((p) => p);
      }

      return [];
    },
    standardProducts(state, getters) {
      const standProduct = state.configSettings.standard?.products;
      const offerProduct = getters.offerProducts;

      if (standProduct && offerProduct) {
        return standProduct.map((p) => getProductInfo(offerProduct, p['product-code'])).filter((p) => p);
      }

      return [];
    },
    secondaryProducts(state, getters) {
      const secProduct = state.configSettings.secondary?.products;
      const offerProduct = getters.offerProducts;

      if (secProduct && offerProduct) {
        return secProduct.map((p) => getProductInfo(offerProduct, p['product-code'])).filter((p) => p);
      }

      return [];
    },
    availablePaymentForStaff(state) {
      return state.configSettings["staff-payment-types"].split(',');
    },
    isStaffUser(state) {
      const roleValidation = (role) => ['AdminPortal', 'CHQStaff', 'LPANSWStaff'].includes(role);
      return state.donorRole.some(roleValidation);
    },
  }
}
